import type { AssetMetadata } from '../types/asset-metadata';
import type { CSSProperties } from 'react';

export type HeaderCrop = { x: number; y: number; zoom?: number };

export const getHeaderCrop = (metadata?: AssetMetadata | null): HeaderCrop => ({
  x: metadata?.header_crop?.x ?? 50,
  y: metadata?.header_crop?.y ?? 50,
  zoom: metadata?.header_crop?.zoom ?? 1,
});

export const getHeaderPosition = (crop: HeaderCrop): string => `${crop.x}% ${crop.y}%`;

export const getHeaderImageStyle = (crop: HeaderCrop): CSSProperties => ({
  objectPosition: getHeaderPosition(crop),
  transform: `scale(${crop.zoom ?? 1})`,
  transformOrigin: getHeaderPosition(crop),
});

export const moveHeaderCrop = (
  crop: HeaderCrop,
  deltaX: number,
  deltaY: number,
  width: number,
  height: number,
  imageWidth: number,
  imageHeight: number,
): HeaderCrop => {
  const scale = Math.max(width / imageWidth, height / imageHeight) * (crop.zoom ?? 1);
  const overflowX = imageWidth * scale - width;
  const overflowY = imageHeight * scale - height;
  const clamp = (value: number) => Math.max(0, Math.min(100, value));

  return {
    ...crop,
    x: overflowX > 0.01 ? clamp(crop.x - deltaX / overflowX * 100) : crop.x,
    y: overflowY > 0.01 ? clamp(crop.y - deltaY / overflowY * 100) : crop.y,
  };
};
